import { Link } from 'gatsby';
import { useI18next } from 'gatsby-plugin-react-i18next';
import React, { useMemo, useEffect } from 'react';
import moment from 'moment';
import { PlayIcon } from '@heroicons/react/24/solid';
import { AdvancedImage, placeholder, lazyload, responsive } from '@cloudinary/react';
import { Cloudinary } from '@cloudinary/url-gen';
import { thumbnail } from '@cloudinary/url-gen/actions/resize';
import { focusOn } from '@cloudinary/url-gen/qualifiers/gravity';
import { FocusOn } from '@cloudinary/url-gen/qualifiers/focusOn';
import CategoryBadge from './CategoryBadge';
interface IPostCategory {
  name: string;
  slug: string;
  weight: number;
}

function PostCard({ post, category, showBadge }: { post: any; category?: IPostCategory; showBadge: boolean }) {
  const { i18n } = useI18next();


  const [isSafari, setIsSafari] = React.useState(false);
  
  useEffect(() => {
    let agent = parseUserAgent(navigator.userAgent)
    setIsSafari(agent);
  //console.log('navigator.userAgent',agent);
  }, [])


  const parseUserAgent = (pathname) => {
    const isSafari = /^((?!chrome).)*safari/i.test(pathname);
    return isSafari;
  };

  const postCategory: IPostCategory = useMemo(
    () =>
      post?.categories?.reduce(
        (prev: IPostCategory, current: IPostCategory) => (prev.weight < current.weight ? prev : current),
        0
      ),
    [post?.categories]

  );

  const cld = new Cloudinary({
    cloud: {
      cloudName: process.env.GATSBY_CLOUDINARY_CLOUD_NAME,
    },
  });

  const postImage = useMemo(() => {
    const imgUrl = post?.image?.url;
    const imgFilename = imgUrl?.substring(imgUrl.lastIndexOf('/') + 1);
    let image:any = cld.image(`/${process.env.GATSBY_CLOUDINARY_FOLDER}/${imgFilename}`);
    image.resize(thumbnail().width(200).height(200).gravity(focusOn(FocusOn.face()))).format('auto');
    //image = getImage(image);
    return image;
  }, [post?.image?.url]);

  return (
    <div className="lg:w-1/2">
      <a
        href={blogPostUrl(i18n.language, post?.slug, 'ar')}
        className="flex flex-row border shadow rounded-xl p-2 mb-3 mx-1 bg-white"
      >
        <div className="w-1/3 relative">
          {category?.slug === 'video' && (
            <PlayIcon
              fill="white"
              stroke="white"
              className="h-8 w-8 lg:h-12 lg:w-12 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
            />
          )}
          {postImage && (
            <AdvancedImage
              className="rounded-xl aspect-square"
              alt={post?.slug}
              cldImg={postImage}
              loading="lazy"
              width="200"
              height="200"
              plugins={[lazyload({rootMargin: '0px', threshold: 0.5}), responsive({ steps: 200 }), placeholder()]}
            />
          )}
        </div>
        <div className="w-2/3 flex flex-col ltr:pl-4 rtl:pr-4 px-4 pt-1">
          {showBadge && <CategoryBadge title={category?.name ?? postCategory?.name} />}
          <h3 className={`lg:text-lg text-base text-omooma-dark-grey mt-2 ltr:font-headline  ${isSafari ? 'rtl:font-bodyEn ltr:font-headline whitespace-pre-wrap' : 'rtl:font-bodyAr'} leading-7 `}>
            {post?.title}
          </h3>
          <span className="text-sm text-omooma-dark-light mt-2 ltr:font-body rtl:font-bodyAr">
            {moment(post?.publish_at ?? post?.publishedAt).format('MMMM Do YYYY')}
          </span>
        </div>
      </a>
    </div>
  );
}
export const blogPostUrl = (language: string, slug: string | null, defaultLanguage: string) => {
  if (language && language !== defaultLanguage) return `/${language}/p/${slug}/`;
  else return `/p/${slug}/`;
};

export default PostCard;
